<template>
  <ul v-if="languages.length" id="editor">
    <!-- paragraphs -->
    <li class="row" v-for="(id, i) in paragraphOrder" :key="i">
      <p
        class="box paragraph-text editable"
        contentEditable
        v-for="(language, k) in languages"
        :class="{ new: !paragraphs[id][language] }"
        :key="k"
        :data-id="id"
        :data-language="language"
        @blur="onTextChange"
        @keydown.enter="blur"
        @keydown.escape="blur"
      >
        {{ paragraphs[id][language] || " " }}
      </p>
      <div class="box"></div>
    </li>

    <!-- editing tools -->
    <li class="row">
      <Button @click="$emit('addParagraph')">Add Paragraph</Button>
    </li>
  </ul>
  <div class="ui" v-else>
    <p>Your document is currently empty!</p>
    <p>
      Use one of the buttons in the top right to import a document from raw text
      or from a file. Or, start writing by clicking "Add Language".
    </p>
  </div>
</template>

<script>
export default {
  name: "Editor",
  components: {},
  data() {
    return {};
  },
  methods: {
    onTextChange(ev) {
      const id = ev.target.attributes["data-id"].value;
      const language = ev.target.attributes["data-language"].value;
      const value = ev.target.innerText;
      this.$emit("textChange", id, language, value);
    },
    blur(ev) {
      ev.preventDefault();
      ev.target.blur();
    }
  },
  props: {
    languages: Array,
    paragraphs: Object,
    paragraphOrder: Array
  }
};
</script>

<style>
.paragraph-text {
  display: flex;
  flex-grow: 1;
  word-break: break-word;
  min-height: 1.5rem;
}
.paragraph-text.new {
  background-color: #eee;
}
.editable:hover {
  outline: 1px dotted black;
}
</style>
